angular
    .module('app')
    .component('usersAdd', {
        templateUrl: '/templates/pages/users/usersAdd/usersAdd.html',
        controller: 'UsersAddController',
        controllerAs: 'vm',
    });